import React from 'react'

import * as Styled from './ChartPlaceholder.styled'
import { Icon2 } from '@elamajs/ui-kit'

const ChartPlaceholder = () => (
  <Styled.Container>
    <Styled.Grid>
      {Array(5)
        .fill(0)
        .map((_, index) => (
          <Styled.Row key={index}>
            <Styled.YAxisRectange />
            <Styled.Line />
          </Styled.Row>
        ))}
    </Styled.Grid>
    <Styled.XAxis>
      {Array(13)
        .fill(0)
        .map((_, index) => (
          <Styled.XAxisDot key={index} />
        ))}
    </Styled.XAxis>
    <Styled.Average />
    <NoDataMessage />
  </Styled.Container>
)

const NoDataMessage = () => (
  <Styled.NoDataMessage>
    <Icon2 size="m" icon="forbidden" color="#858FAD" />
    <span>За этот период нет данных</span>
  </Styled.NoDataMessage>
)

export default ChartPlaceholder

export { NoDataMessage }
